import EmployeeActionsSection from './EmployeeActionsSection'

export default EmployeeActionsSection
